@if (!show) {
  <div class="lightspeed"></div>
} @else {
  <div class="animate__animated animate__lightSpeedInRight" style="background: #5c2597; width: 100%">
    @if (data === 'home') {
      <div class="slide-wrapper">
        <!-- <div id="closebt-container" class="close-lightSpeedIn"> -->
        <div class="onboarding-page onboarding-page-one">
          <span class="onboarding-page-close-btn" (click)="closeOnbording()" class="close-lightSpeedIn">
            <img class="onboarding-page-close" src="../../../assets/icon/close-icon.svg" />
          </span>
          <img class="onboarding-page-main" src="../../../assets/icon/onboarding-one.png" />
        </div>
      <!-- </div> -->
    </div>
  }
</div>
<div class="animate__animated animate__lightSpeedInRight" style="background: #5c2597; width: 100%">
  @if (data === 'syndicate') {
    <div class="slide-wrapper">
      <div class="onboarding-page onboarding-page-two">
        <!-- <div id="closebt-container" class="close-lightSpeedIn"> -->
        <span class="onboarding-page-close-btn" (click)="closeOnbording()">
          <img class="onboarding-page-close" src="../../../assets/icon/close-icon.svg" />
        </span>
        <img class="onboarding-page-main" src="https://firebasestorage.googleapis.com/v0/b/lottosocial-9f7a2.appspot.com/o/app%2Fonboarding-two_200x200.webp?alt=mediag" />
      <!-- </div> -->
    </div>
  </div>
  }
</div>
<div class="animate__animated animate__lightSpeedInRight" style="background: #5c2597; width: 100%">
  @if (data === 'store') {
    <div class="slide-wrapper">
      <!-- <div class="onboarding-page onboarding-page-three"> -->
      <span class="onboarding-page-close-btn" (click)="closeOnbording()">
        <img class="onboarding-page-close" src="../../../assets/icon/close-icon.svg" />
      </span>
      <img class="onboarding-page-main" src="https://firebasestorage.googleapis.com/v0/b/lottosocial-9f7a2.appspot.com/o/app%2Fonboarding-three_200x200.webp?alt=media" />
    <!-- </div> -->
  </div>
}
</div>
}

